import { render, staticRenderFns } from "./gain.vue?vue&type=template&id=150bd977&scoped=true&"
import script from "./gain.vue?vue&type=script&lang=js&"
export * from "./gain.vue?vue&type=script&lang=js&"
import style0 from "./gain.vue?vue&type=style&index=0&id=150bd977&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150bd977",
  null
  
)

export default component.exports